import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, getCurrentInstance } from 'vue';
import { CrewsTable } from '@/components/views/Logistics';


export default /*#__PURE__*/_defineComponent({
  __name: 'MontageTeamsSection',
  props: {
    data: null,
    columns: null,
    selectedRowKeys: null
  },
  emits: ["onRowClick", "delete", "update:selectedRowKeys"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'onRowClick', record: Record<string, any>, section: string): void;
    (e: 'delete', ids: string[], section: string): void;
    (e: 'update:selectedRowKeys', keys: string[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    data: any[];
    columns: any[];
    selectedRowKeys: string[];
};

const search = ref('');
const { proxy } = getCurrentInstance()!;





const filteredData = computed(() => {
    if (!search.value) {
        return props.data;
    }
    const searchLower = search.value.toLowerCase();
    return props.data.filter(
        (item: any) =>
            item.name?.toLowerCase().includes(searchLower) ||
            item.lastName?.toLowerCase().includes(searchLower) ||
            item.driver?.toLowerCase().includes(searchLower) ||
            item.teamLeader?.toLowerCase().includes(searchLower) ||
            item.installer?.toLowerCase().includes(searchLower) ||
            item.vehicleRegistration?.toLowerCase().includes(searchLower),
    );
});

function handleRowClick(record: any) {
    emits('onRowClick', record, 'montageTeams');
}

function handleDeleteSelected() {
    emits('delete', props.selectedRowKeys, 'montageTeams');
}

return { __sfc: true,search, proxy, props, emits, filteredData, handleRowClick, handleDeleteSelected, CrewsTable }
}

})